import validator from 'validator'
import moment from 'moment'
import _ from 'lodash'

class Validator {
  static isLength(str, options, errMsg) {
    if (!validator.isLength(str, options)) {
      throw new Error(errMsg)
    }
  }

  static isEmail(str, errMsg) {
    if (!validator.isEmail(str)) {
      throw new Error(errMsg)
    }
  }

  static isMobilePhone(str, locale, errMsg) {
    if (locale[0] === 'zh-CN') {
      const cnPhoneRegex = /^1[3-9]\d{9}$/
      if (!cnPhoneRegex.test(str)) {
        throw new Error(errMsg)
      }
    } else if (!validator.isMobilePhone(str, locale)) {
      throw new Error(errMsg)
    }
  }

  static isDate(str, format, errMsg) {
    const date = moment(str, format)
    if (!date.isValid()) {
      throw new Error(errMsg)
    }
  }

  static isTime(str, format, errMsg) {
    const time = moment(str, format)
    if (!time.isValid()) {
      throw new Error(errMsg)
    }
  }

  static isDateTime(str, format, errMsg) {
    const datetime = moment(str, format)
    if (!datetime.isValid()) {
      throw new Error(errMsg)
    }
  }

  static isIdCard(str, errMsg) {
    // const res = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.exec(
    //   str
    // )
    // if (res == null) {
    //   throw new Error(errMsg)
    // }

    const id = str
    var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/
    // 号码规则校验
    if (!format.test(id)) {
      throw new Error(errMsg)
    }
    // 区位码校验
    // 出生年月日校验   前正则限制起始年份为1900;
    var year = id.substr(6, 4) // 身份证年
    var month = id.substr(10, 2) // 身份证月
    var date = id.substr(12, 2) // 身份证日
    var time = Date.parse(month + '-' + date + '-' + year) // 身份证日期时间戳date
    var nowTime = Date.parse(new Date()) // 当前时间戳
    var dates = new Date(year, month, 0).getDate() // 身份证当月天数
    if (time > nowTime || date > dates) {
      throw new Error(errMsg)
    }
    // 校验码判断
    var c = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2] // 系数
    var b = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'] // 校验码对照表
    var idArray = id.split('')
    var sum = 0
    for (var k = 0; k < 17; k++) {
      sum += parseInt(idArray[k]) * parseInt(c[k])
    }
    const res = idArray[17].toUpperCase() === b[sum % 11].toUpperCase()
    if (!res) {
      throw new Error(errMsg)
    }
  }

  static isSupportFileType(fileType, supportTypes, errMsg) {
    const res = _.includes(supportTypes, fileType)
    if (!res) {
      throw new Error(errMsg)
    }
  }

  static isSupportFileSize(fileSize, supportSize, errMsg1, errMsg2) {
   
    if (supportSize.length === 2) {
      if (fileSize > supportSize[1]) {
        throw new Error(errMsg1)
      }
      if (fileSize < supportSize[0]) {
        throw new Error(errMsg2)
      }
    } else if (fileSize > supportSize[0]) {
      throw new Error(errMsg1)
    }
  }

  static isSupportImageSize(imageSize, supportSize, errMsg) {
    const { width, height } = imageSize
    const {
      supportMinWidth,
      supportMaxWidth,
      supportMinHeight,
      supportMaxHeight
    } = supportSize

    const res =
      width >= supportMinWidth &&
      width <= supportMaxWidth &&
      height >= supportMinHeight &&
      height <= supportMaxHeight
    if (!res) {
      throw new Error(errMsg)
    }
  }

  static isInputComponent(item) {
    return item.type === 'jtInput'
  }

  static isEmailComponent(item) {
    return item.type === 'jtEmail'
  }

  static isPhoneComponent(item) {
    return item.type === 'jtPhone'
  }

  static isDateComponent(item) {
    return item.type === 'jtDate'
  }

  static isTimeComponent(item) {
    return item.type === 'jtTime'
  }

  static isDateTimeComponent(item) {
    return item.type === 'jtDateTime'
  }

  static isIdCardComponent(item) {
    return item.type === 'jtIdCard'
  }
  static isIdCardGlobalComponent(item) {
    return item.type === 'jtIdCardGlobal'
  }
  static isSingleProjectComponent(item) {
    return item.type === 'jtSingleProject'
  }

  static isGroupProjectComponent(item) {
    return item.type === 'jtGroupProject'
  }

  static isSelectComponent(item) {
    return item.type === 'jtSelect'
  }

  static isImageComponent(item) {
    return item.type === 'jtImage'
  }

  static isMusicComponent(item) {
    let a = item.type === 'jtMusic'
    return a
  }
  static isVideoComponent(item) {
    return item.type === 'jtVideo'
  }
  static isBigVideoComponent(item) {
    return item.type === 'jtBigVideo'
  }
  static isHtmlComponent(item) {
    return item.type === 'jtHtml'
  }
  static isDistrictComponent(item) {
    return item.type === 'jtDistrict'
  }
  static isGroupSelectComponent(item) {
    return item.type === 'jtGroupSelect'
  }
  static isJtStatusButtonComponent(item) {
    return item.type === 'jtStatusButton'
  }
  static isRedirectPageComponent(item) {
    return item.type === 'jtRedirectPage'
  }
  static isHtmlEditComponent(item) {
    return item.type === 'jtHtmlEdit'
  }
  static isLimitSingleComponent(item) {
    return item.type === 'jtLimitSingle'
  }
  static isActionsComponent(item) {
    return item.type === 'jtActions'
  }
  static isLimitTextComponent(item) {
    return item.type === 'jtLimitText'
  }
  static isjtLimitGroupComponent(item) {
    return item.type === 'jtLimitGroup'
  }
  static isjtTaoluRequiredComponent(item) {
    return item.type === 'jtTaoluRequired'
  }
  static isjtTaoluDifficultyComponent(item) {
    return item.type === 'jtTaoluDifficulty'
  }
  static isSingleSelectComponent(item) {
    return item.type === 'jtSingleSelect'
  }

  static isFileComponent(item) {
    return item.type === 'jtFile'
  }
}

export default Validator
